// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellCircle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-circle': IconBellCircle;
    }
}

/**
 * The icon component for the 'bellCircle' icon
 */
export class IconBellCircle extends Icon {
    public constructor() {
        super(bellCircle16X16);
    }
}

registerIcon('icon-bell-circle', IconBellCircle);
export const iconBellCircleTag = 'nimble-icon-bell-circle';
